import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Stack,
} from "@mui/material";
// hooks
import useAuth from "../../../hooks/useAuth";
import useResponsive from "../../../hooks/useResponsive";
// components
import SvgIconStyle from "../../../components/SvgIconStyle";
// utils
import axios from "../../../utils/axios";
import Image from '../../../components/Image';

// ----------------------------------------------------------------------

export default function ParttimeOfferDialog({ isOpen, closeDialog, coffeeChat, moveToContinueWork }) {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');

  const notiSelectContinueWork = async () => {
    // 업무 제안 선택 알림
    try {
      axios.post(`/api/company/${user?.employee?.company?.[0].id}/fliers/coffee/${coffeeChat?.id}/click-parttime/`, {
      });
    } catch(err) {
      console.error(err);
    }
  };

  const offer = async () => {
    notiSelectContinueWork();
    moveToContinueWork();
  }

  return (
    <Dialog open={isOpen} maxWidth="dg" fullWidth>
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Typography variant="h5" gutterBottom>
          {coffeeChat?.crew?.nickname} 크루에게 <br />
          맡기실 업무를 제안해주세요.
        </Typography>
        {smUp && (
          <Image
            alt="offer-pc"
            src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/fliers/coffee_chat_parttime_dialog_pc.png"
            srcSet="
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/fliers/coffee_chat_parttime_dialog_pc.png 1x,
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/fliers/coffee_chat_parttime_dialog_pc_2x.png 2x,
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/fliers/coffee_chat_parttime_dialog_pc_3x.png 3x,
            "
            sx={{ my: 2 }}
          />
        )}
        {!smUp && (
          <Image
            alt="offer-mo"
            src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/fliers/coffee_chat_parttime_dialog_mo.png"
            srcSet="
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/fliers/coffee_chat_parttime_dialog_mo.png 1x,
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/fliers/coffee_chat_parttime_dialog_mo_2x.png 2x,
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/fliers/coffee_chat_parttime_dialog_mo_3x.png 3x,
            "
            sx={{ my: 2 }}
          />
        )}
        <Stack direction="row" spacing={1}>
          <SvgIconStyle src={`/icons/ic_check.svg`} sx={{ color: "oldprimary.main", width: 20, height: 20 }} />
          <Typography variant="body2">
            업무 내용을 확인하고, 크루가 계약 조건(업무 시간, 인건비)을 제안해요.
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
          <SvgIconStyle src={`/icons/ic_videocam.svg`} sx={{ color: "info.main", width: 20, height: 20 }} />
          <Typography variant="body2">
            크루에게 미팅을 한번 더 요청할 수 있어요.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack
          direction={{ xs: "column-reverse", sm: "row" }}
          spacing={1}
          sx={{ px: { xs: 0, sm: 1 }, width: 1, justifyContent: "flex-end" }}
        >
          <Button
            size="large"
            onClick={(e) => { e.stopPropagation(); closeDialog(); }}
            sx={{ px: 4 }}
          >
            취소
          </Button>
          <Button
            size="large"
            variant="contained"
            onClick={(e) => { e.stopPropagation(); offer(); }}
            sx={{ px: 4 }}
          >
            업무 제안하기
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
